const STORAGE_KEY = "constructpay.auth.returnPath";
const BONDREADY_PATH = /^\/bondready\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function candidatePath(candidate) {
  if (typeof candidate === "string") return candidate;
  if (candidate && typeof candidate.pathname === "string") {
    if (candidate.search || candidate.hash) return null;
    return candidate.pathname;
  }
  return null;
}

/** Only exact in-app BondReady opportunity paths are eligible auth return targets. */
export function safeBondReadyReturnPath(candidate) {
  const path = candidatePath(candidate);
  if (!path || path.includes("\\") || path.startsWith("//") || !BONDREADY_PATH.test(path)) {
    return null;
  }
  return path;
}

export function rememberAuthReturnPath(candidate) {
  const safePath = safeBondReadyReturnPath(candidate);
  if (!safePath) return null;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, safePath);
  } catch (_error) {
    return null;
  }
  return safePath;
}

export function consumeAuthReturnPath(candidate) {
  const statePath = safeBondReadyReturnPath(candidate);
  let storedPath = null;
  try {
    storedPath = safeBondReadyReturnPath(window.sessionStorage.getItem(STORAGE_KEY));
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (_error) {
    // Browser storage is optional; an exact in-memory route state remains usable.
  }
  return statePath || storedPath;
}

export const authReturnStorageKey = STORAGE_KEY;
